module.exports = __webpack_public_path__ + "img/price_group.7b7e3415.svg";